import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";

type SideHeaderProps = {
  img?: string | null;
  name: string;
  usertype: string;
  actionName?: string;
  action: any;
};
function SideHeader({
  img,
  name,
  usertype,
  actionName,
  action,
}: SideHeaderProps) {
  return (
    <div className="text-center border-b mx-2 border-gray-200 pb-4">
      <UserProfilePictureAvatar
        profilePictureUrl={img}
        className="w-12 h-12 mx-auto"
        alt="sand-user-img"
      />
      <h1 className="text-grey-700 text-sm	"> {name} </h1>
      <div className="flex items-center justify-center	">
        <p className="text-grey-700 text-sm"> {usertype} </p>
        {!!actionName && (
          <button className="px-1" onClick={() => action()}>
            <p className="text-brandblue-700 text-sm"> {actionName} </p>
          </button>
        )}
      </div>
    </div>
  );
}
export default SideHeader;
